var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dynamic-checkbox form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "disabled": _vm.disabled,
      "id": _vm.id
    },
    domProps: {
      "checked": _vm.modelValue.includes(_vm.value),
      "value": _vm.value
    },
    on: {
      "change": function change($event) {
        _vm.$emit('input', _vm.modelValue.includes($event.target.value) ? _vm.modelValue.filter(function (v) {
          return v !== $event.target.value;
        }) : _vm.modelValue.concat($event.target.value));
      }
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }